import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'
import App from './App'
import './index.css'
import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'

// Configure status bar on native — dark icons on light bg, light icons on dark bg
if (Capacitor.isNativePlatform()) {
  const applyStatusBar = () => {
    const isDark = document.documentElement.classList.contains('dark')
    StatusBar.setStyle({ style: isDark ? Style.Dark : Style.Light })
    StatusBar.setBackgroundColor({ color: isDark ? '#141414' : '#ffffff' })
  }
  applyStatusBar()
  // Re-apply when theme changes
  const observer = new MutationObserver(applyStatusBar)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
}

// Suppress PostHog remote-config CDN fetch (non-fatal 404 noise)
// @ts-ignore
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.__PosthogExtensions__ = window.__PosthogExtensions__ || {}
  // @ts-ignore
  window.__PosthogExtensions__.loadExternalDependency = () => Promise.resolve()
}

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_TOKEN, {
  api_host: 'https://us.i.posthog.com',
  autocapture: false,
  advanced_disable_feature_flags: true,
} as any)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </StrictMode>,
)
